/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** B3 single-header key */
export var B3_CONTEXT_HEADER = 'b3';
/* b3 multi-header keys */
export var X_B3_TRACE_ID = 'x-b3-traceid';
export var X_B3_SPAN_ID = 'x-b3-spanid';
export var X_B3_SAMPLED = 'x-b3-sampled';
export var X_B3_PARENT_SPAN_ID = 'x-b3-parentspanid';
export var X_B3_FLAGS = 'x-b3-flags';
//# sourceMappingURL=constants.js.map